import { useDebouncedState } from '@react-hookz/web/useDebouncedState/index.js';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getAccountAccessRedirectUrls } from '@data/account-access';
import { getRedirectUrlsFromPayment } from '@data/global-api-payments';
import { useLiveRegion } from '@state/checkout-contexts';
import {
  CURRENT_SERVICE_TYPE,
  getPaymentRequestId,
  SERVICE_TYPE,
} from '@utility/checkout-utils';

import { FLOW_TYPE } from '../global.constants';
import { useJwtContext } from '../hooks/useJwtContext/useJwtContext';
import { useScaSubject } from '../providers/ScaSubjectProvider/ScaSubjectProvider.hooks';
import { dataLayer } from '../utils/dataLayer';
import { redirectOutsideSca } from '../utils/redirectOutsideSca';
import { TRANSLATION_KEYS } from '../utils/TranslationKeys';

export const useTrackGlobalDataLayerProperties = () => {
  const paymentId = getPaymentRequestId() ?? '';
  const { payload } = useJwtContext();
  const { institutionId, customerId, initiationChannel } = payload ?? {};

  useEffect(() => {
    const serviceType =
      CURRENT_SERVICE_TYPE === SERVICE_TYPE.PIS ? FLOW_TYPE.PIS : FLOW_TYPE.AIS;

    dataLayer.addGlobalEventProperties({
      serviceType,
    });
  }, []);

  useEffect(() => {
    dataLayer.addGlobalEventProperties({
      paymentId,
      institutionId,
      customerId,
      initiationChannel,
    });
  }, [paymentId, institutionId, customerId, initiationChannel]);
};

export const useRedirectOutsideSca = () => {
  const { subject } = useScaSubject();

  useEffect(() => {
    if (subject && 'paymentInitiationFlow' in subject) {
      const { directUrl } = getRedirectUrlsFromPayment(subject);

      if (directUrl) {
        redirectOutsideSca(directUrl, subject?.status);
      }
    }

    if (subject && 'accountAccessFlow' in subject) {
      const { directUrl } = getAccountAccessRedirectUrls(subject);

      if (directUrl) {
        redirectOutsideSca(directUrl, subject?.status?.status);
      }
    }
  }, [subject]);
};

export const useWarnAboutMissingToken = () => {
  const { payload, tokenError } = useJwtContext();

  useEffect(() => {
    if (tokenError) {
      console.error(new Error('`token` must be provided'));
    }
  }, [tokenError, payload]);
};
